import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=4d563d7b&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports